import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { StandaloneForm } = await import('./index');
    return {
        Component: StandaloneForm,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
